import QuickQuincyHome from "./QuincyHome";
import QuickQuincyGoals from "./QuincyGoals";

const QuickQuincy = {
  Home: QuickQuincyHome,
  Goals: QuickQuincyGoals,
};

export default QuickQuincy;
